import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import SystemsightFormConditions from "./modules/cms-form-conditions";
import "./modules/cms-ajax-form";
import "./modules/cms-autocomplete";
import "./modules/cms-password";
import CmsSelect2 from "./modules/cms-select2";
import CmsDatepicker from "./modules/cms-datepicker";
import CaptchaInput from "./modules/cms-captcha";
//import "./modules/old-browser-check"

global.$ = $;
global.jQuery = $;
window.$ = $;

//modal auto open
$('[role="dialog"][data-open="true"]').each(function(){
    this.modal_inst = new bootstrap.Modal(this);
    this.modal_inst.show();
});
$('[data-toggle="tooltip"],[data-bs-toggle="tooltip"]').each(function(){
    this.tooltip_inst = new bootstrap.Tooltip(this);
});

$('body').on('click', 'a[data-confirm],button[data-confirm]', function (e) {//a confirm
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    }else{
        $(this).trigger('click-confirmed', e);
    }
}).on('click', 'a[data-open="modal"]', function (e) {//open link as modal
    let modalHtml = '<div class="modal fade" role="dialog">\n' +
        '    <div class="modal-dialog modal-xl">\n' +
        '        <div class="modal-content">' +
        '            <div class="modal-body">\n' +
        '<div class="text-center p-5"><div class="spinner-border" role="status">\n' +
        '  <span class="sr-only">Loading...</span>\n' +
        '</div></div>'
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>';

    let $modal = $(modalHtml);
    let $link = $(this);
    $('body').append($modal);

    //let modal_inst = new bootstrap.Modal($modal.get(0));
    let modal_inst = new bootstrap.Modal($modal);
    modal_inst.show();

    $modal.on('shown.bs.modal', function (e) {
        $.ajax($link.attr('href')).done(function (result) {
            $modal.find('.modal-body').html(result);
            //$modal.modal('handleUpdate');

            if($modal.find('form').length){
                CmsSelect2.init_select2_all();
                CmsDatepicker.init_datepickers();
                SystemsightFormConditions.init_conditions();
                CaptchaInput.init();
            }
        });
    }).on('hidden.bs.modal', function () {
        $modal.remove();
    });
    e.preventDefault();
});

//lang switcher
$('.lang-switch .i18n_btn').click(function(e){
    $('.lang-switch .i18n_btn').removeClass('active');
    $('.i18n_btn_'+$(this).data('translate')).addClass('active');

    $('.i18n').addClass('d-none');
    $('.i18n_'+$(this).data('translate')).removeClass('d-none');

    $(this).blur();
});
//-----------------------------------------------------------

//nav's and content overlay
var showContentOverlay = function(caller){
    $('.content-overlay').show().attr('data-caller', caller);
};
var hideContentOverlay = function(){
    $('.content-overlay').hide().removeAttr('data-caller', '');
};
var jNavToggler = $('.nav-toggler');
var jUserMenuToggler = $('#userDropdownMenuButton');
jNavToggler.on('click', function () {
    $(this).blur();
});
jNavToggler.each(function(){
    var jButton = $(this);
    var jTarget = $(jButton.data('bs-target'));

    jTarget.on('show.bs.collapse', function(e){
        var that = $(e.target);
        var jButton = $('[data-bs-target="#' + that.attr('id') + '"]');

        //close other panels
        $('.nav-toggler[aria-expanded="true"]:not([data-bs-target="#' + that.attr('id') + '"])').trigger('click');

        showContentOverlay(jButton.data('caller') || '');
    });
    jTarget.on('hidden.bs.collapse', function (e){
        var that = $(e.target);

        if(!$('.nav-toggler[aria-expanded="true"]:not([data-bs-target="#' + that.attr('id') + '"])').length) {
            hideContentOverlay();
        }
    });
});
$('.content-overlay').on('click', function(){
    var jToggler = $('.nav-toggler[aria-expanded="true"]');
    if(jToggler.length) {
        jToggler.trigger('click');
    } else {
        hideContentOverlay();
    }
});

jUserMenuToggler.on('show.bs.dropdown', function(e){
    var jToggler = $('.nav-toggler[aria-expanded="true"]');
    if(jToggler.length) {
        jToggler.trigger('click');
    }
    showContentOverlay('user_menu');
});
jUserMenuToggler.on('hidden.bs.dropdown', function(e){
    var that = $(e.target);

    if(!$('.nav-toggler[aria-expanded="true"]:not([data-bs-target="#' + that.attr('id') + '"])').length) {
        hideContentOverlay();
    }
});
//-----------------------------------------------------------

if(typeof $.fn.fancybox !== 'undefined') {
    $('a.fancybox').fancybox();

    $('.fancy-popup').fancybox({
        type: "iframe",
        toolbar  : false,
        smallBtn : true,
        afterClose : function(instance, slide) {
            if(instance.$trigger.data('reload-after-close')) {
                window.location.reload();
            }
        }
    });
}
//-----------------------------------------------------------
$(function(){
    $('.addto_actual_list').on('click', function(e){
        e.preventDefault;
        var itemId = $(this).data('id');
        var userId = $(this).data('user');
        var url = $(this).data('action');
        var that = $(this);
        if (userId != '') {
            $.ajax({
                type: "POST",
                url: url,
                data: {item: itemId},
                dataType: "json",
                success: function (response) {
                    if (response.success) {
                        that.append('<span class="badge bg-success">'+response.success+'</span>');
                        setTimeout(function(){ that.children('.badge').remove(); }, 3000);
                    } else if (response.error) {
                        that.append('<span class="badge bg-danger">'+response.error+'</span>');
                        setTimeout(function(){ that.children('.badge').fadeOut(100, function(){ $(this).remove() }); }, 3000);
                    }
                }
            });
        } else {
            that.append('<span class="badge bg-danger">'+that.data('unauthorized')+'</span>');
            setTimeout(function(){ that.children('.badge').fadeOut(100, function(){ $(this).remove() }); }, 3000);
        }
    });

    $('.removefrom_actual').on('click', function(e){
        e.preventDefault;
        var itemId = $(this).data('id');
        var userId = $(this).data('user');
        var url = $(this).data('action');
        var that = $(this);
        ;
        if(confirm($(this).data('confimartion')))
        {
            if (userId != '') {
                $.ajax({
                    type: "POST",
                    url: url,
                    data: {item: itemId, user: userId},
                    dataType: "json",
                    success: function (response) {
                        if (response.success) {
                            that.append('<span class="badge bg-success">'+response.success+'</span>');
                            setTimeout(function(){
                                that.children('.badge').remove();
                                that.closest('.my-2').fadeOut(300, function(){ $(this).remove() });
                            }, 3000);
                        } else if (response.error) {
                            that.append('<span class="badge bg-danger">'+response.error+'</span>');
                            setTimeout(function(){ that.children('.badge').fadeOut(300, function(){ $(this).remove() }); }, 3000);
                        }
                    }
                });
            } else {
                that.append('<span class="badge bg-danger">'+that.data('unauthorized')+'</span>');
                setTimeout(function(){ that.children('.badge').fadeOut(300, function(){ $(this).remove() }); }, 3000);
            }
        }
    });
});
//-----------------------------------------------------------

$(function (){
    $('#deleteModal').on('show.bs.modal', function (e) {
        let id = e.relatedTarget.getAttribute('data-bs-id');
        let button = $('#deleteModal .btn-primary');
        button.attr('href', button.data('link') + id);
    });
});
//-----------------------------------------------------------

/**
 * Specialus zymejimas keiciamas issikleidzianciu sarasu
 * Pastaba: turi buti atliktas dar pries visus kitus funkcionalumo nustatymus
 */
var jTextWrapper = $('.text');
var card_index = 0;
jTextWrapper.each(function () {

    var jText = $(this);
    var text = jText.html();

    var replaceMatches = function (group) {
        var i_start = group.start['index'],
            i_end = group.end['index'] + group.end[0].length;
        var html = text.substring(i_start, i_end);

        html = html.replace(/\<p\>\[\[#ex\]\]\<\/p\>/gm, '');

        var lines = html.split(/\<hr(?:\s\/\>|\/\>|\>)/gm);

        var jExWrap = $('<div></div>'),
            jEx = $('<div class="panel-group accordion"></div>'),
            jExLine, jHeading, jContent,
            jFirst;

        for (var i = 0; i < lines.length; i++) {
            card_index++;
            jContent = $('<div class="accordion-collapse collapse"></div>');
            jContent.html($.trim(lines[i]));

            jFirst = jContent.find('>*:first');

            if (jFirst.length) {
                var heading_html = '<a class="accordion-button collapsed" data-bs-toggle="collapse"'
                    + ' href="#ex-' + card_index + '" aria-expanded="false">'
                    + jFirst.text() + '</a>'
                ;

                jHeading = $('<h4 class="accordion-header"></h4>');
                jHeading.html(heading_html);
            }

            if (jContent.find('>*').length > 1) {
                jFirst.remove();
            }

            jContent
                .html('<div class="accordion-body clearfix">' + jContent.html() + '</div>')
                .attr('id', 'ex-' + card_index);

            jExLine = $('<div class="accordion-item"></div>');
            jExLine
                .append(jHeading)
                .append(jContent);
            jEx.append(jExLine);
        }
        jExWrap.append(jEx);

        text = text.substring(0, i_start) + jExWrap.html() + text.substring(i_end);
    };

    var group = {}, match;
    var myRegexp = /(?:^|.*)\[\[#ex\]\](?:.*|$)/gm;

    match = myRegexp.exec(text);

    while (match !== null) {
        if (!group.start) {
            group.start = match;
        }
        else {
            group.end = match;
            replaceMatches(group);
            group = {};
        }
        match = myRegexp.exec(text);
    }

    text = text.replace(/\<p\>\[\[#ex\]\]\<\/p\>/gm, '');
    jText.html(text);
});
//---------------------------------------------------

//Kvieciamas baigus visus turinio apdorojimus
$(document).trigger('scripts_ready');
//---------------------------------------------------
